import React from 'react';
import { FiRefreshCw, FiX, FiDownload } from 'react-icons/fi';
import useUpdateNotification from './useUpdateNotification';
import {
  BannerWrapper, BannerCard, IconWrapper, TextContent, Title, Description, ActionButtons,
  PrimaryButton, SecondaryButton, DismissButton, MobileLayout, MainContent
} from './UpdateNotification.styles';

const UpdateNotification = ({
  isVisible,
  onRefresh,
  onDismiss,
  onLater,
  autoRefresh = false,
  countdown = 0
}) => {
  const {
    timeLeft, isClosing, shouldRender, handleDismissClick, handleLaterClick, isHiddenInSession
  } = useUpdateNotification({ isVisible, onRefresh, onDismiss, onLater, autoRefresh, countdown });

  if (!shouldRender || isHiddenInSession) return null;

  return (
    <BannerWrapper
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <BannerCard $isClosing={isClosing}>
        <DismissButton
          onClick={handleDismissClick}
          aria-label="Dismiss update banner"
          title="Dismiss"
        >
          <FiX />
        </DismissButton>
        <MobileLayout>
          <MainContent>
            <IconWrapper>
              <FiDownload />
            </IconWrapper>
            <TextContent>
              <Title>New version available</Title>
              <Description>
                Refresh to get the latest features and fixes.
                {autoRefresh && timeLeft > 0 && (
                  <span> Auto-refreshing in {timeLeft}s...</span>
                )}
              </Description>
            </TextContent>
          </MainContent>

          <ActionButtons>
            <PrimaryButton onClick={onRefresh}>
              <FiRefreshCw />
              <span>Refresh now</span>
            </PrimaryButton>

            {!autoRefresh && (
              <SecondaryButton onClick={handleLaterClick}>
                Later
              </SecondaryButton>
            )}

          </ActionButtons>
        </MobileLayout>
      </BannerCard>
    </BannerWrapper>
  );
};

export default UpdateNotification;
